/* 2026-09-16: 跨面复制元素（#7）—— Copy to face…
   ==================================================================
   场景：T恤前后同图很常用（Printful 叫 "duplicate to other placements"）。
   做法：Layers 面板顶部的按钮（#pfmCopyFaceSection）；点开列出**其它面**的 chip；
         选一面 → 克隆当前选中对象 → **模拟点击既有 placement chip**（复用既有切面 onclick，
         不另写切面）→ 把克隆体落位并加入。
   为什么可以直接加：切面 onclick 内部是「同步」完成 canvas.clear() + 改 currentPlacement +
   resizeCanvasToPrintArea()；异步回调只做「加回目标面已有 art + 重画 grid」，**不会清掉后加的对象**。
   落位语义：以「选中对象的**整体包围盒中心**」对齐目标打印区中心，**保持各对象相对位置**；
             整体放不下才等比收敛到 90%（单对象时包围盒 = 自身 ⇒ 与旧版行为一致）。
   入撤销栈：走 window.__pfmAddObject（统一添加原语，内部已 saveState），不额外补 saveState。
   2026-09-20: 支持**多选**（用户要求「多选也适用于 copy」）——
     ① 选中集合一律取公共原语 window.__pfmSelectedObjs()（已是「fabric 单选 / fabric 多选 /
        图层面板 Multi 勾选」三源并集，只此一份）⇒ 本文件**不写第二份判定**；
     ② 多件时**全部克隆完 → 只切一次面 → 批量加入**（切面会 clear 画布，故不能逐件切）；
     ③ 复制成功后清空 Multi 勾选（切面后旧索引会指向另一批对象，留着会误操作）。
*/
(function () {
  'use strict';

  function CV() { return window.__pfmCanvas || null; }
  function q(id) { return document.getElementById(id); }
  function toast(m) { try { if (window.__pfmToast) window.__pfmToast(m); } catch (e) { } }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }

  function curFace() { return (window.__pfmGetPlacement && window.__pfmGetPlacement()) || 'front'; }
  /* 面名一律复用 placement chip 的文案（label 规则的唯一实现在 rerenderPlacements 里） */
  function chips() { return Array.prototype.slice.call(document.querySelectorAll('#pfmPlacements .pfm-chip')); }
  function labelOf(face) { var c = chips().filter(function (x) { return x.dataset.p === face; })[0]; return c ? c.textContent.trim() : face; }

  function hideList() { var l = q('pfmCopyFaceList'); if (l) l.style.display = 'none'; }

  /* 2026-09-20: 选中对象集合 —— 一律走公共原语 window.__pfmSelectedObjs()（只此一份）；
     原语缺失时兜底：单选 + activeSelection 下钻。**不在此处重复实现判定逻辑。** */
  function selObjs() {
    var out = [];
    try { if (typeof window.__pfmSelectedObjs === 'function') out = window.__pfmSelectedObjs() || []; } catch (e) { out = []; }
    if (!out.length) {
      var c = CV(), o = null;
      try { o = c && c.getActiveObject(); } catch (e) { }
      if (o && String(o.type).toLowerCase() === 'activeselection' && o.getObjects) out = o.getObjects().slice();
      else if (o) out = [o];
    }
    return out.filter(function (o) { return o && !o.isGrid && !o.isPreview; });
  }

  /* 除当前面以外的所有面 */
  function otherFaces() {
    var cur = curFace();
    return chips().map(function (c) { return { p: c.dataset.p, label: c.textContent.trim() }; })
      .filter(function (f) { return f.p && f.p !== cur; });
  }
  /* 该面能否接得住复制 —— 判据 = 有可用打印区（规格表为空/读不到时一律视为可用，避免误禁用） */
  function faceUsable(face) {
    try {
      var pa = (window.__pfmPrintArea && window.__pfmPrintArea()) || {};
      var keys = [];
      for (var k in pa) { if (Object.prototype.hasOwnProperty.call(pa, k)) keys.push(k); }
      if (!keys.length) return true;
      var s = pa[face];
      return !!(s && s.width > 0 && s.height > 0);
    } catch (e) { return true; }
  }

  /* 2026-09-20 用户要求（方案 A）：本行**常驻不隐藏**，状态只有「可选 / 不可选」——
     与操作条 Flip/Duplicate/Delete 的既有约定一致（未选中对象时始终占位并置灰 .pfm-fbtn:disabled）。 */
  function sync() {
    var sec = q('pfmCopyFaceSection'); if (!sec) return;
    sec.style.display = 'block';
    var n = selObjs().length;
    var can = n > 0 && otherFaces().filter(function (f) { return faceUsable(f.p); }).length > 0;
    var btn = q('pfmCopyFaceBtn');
    if (btn) { btn.disabled = !can; btn.setAttribute('aria-disabled', can ? 'false' : 'true'); }
    if (!can) hideList();
  }
  /* 供 hd-layers.js 在「Multi 勾选变化」时回调 —— 勾选不触发 canvas selection 事件，
     不回调的话 Multi 模式下勾选数变化时本区块的显隐不会更新。 */
  window.__hdCopyFaceSync = sync;

  function buildList() {
    var list = q('pfmCopyFaceList'); if (!list) return;
    if (list.style.display !== 'none') { hideList(); return; }   /* 再点一次收起 */
    var others = otherFaces();
    list.innerHTML = others.length
      ? others.map(function (f) {
        /* 可用的面才带 data-cf（委托靠它命中）；不可用的只列出来并置灰 ⇒ 点了无反应 */
        return faceUsable(f.p)
          ? '<div class="pfm-chip" data-cf="' + esc(f.p) + '">' + esc(f.label) + '</div>'
          : '<div class="pfm-chip pfm-chip-off" aria-disabled="true">' + esc(f.label) + '</div>';
      }).join('')
      : '<span class="pfm-copyface-none">No other face</span>';
    list.style.display = 'block';
  }

  /* 轴对齐包围盒（canvas 坐标；自动含旋转与线宽）—— 优先 getBoundingRect，
     退化时按 scaled 尺寸 + origin 反推。 */
  function rectOf(o) {
    try {
      if (o.getBoundingRect) {
        var r = o.getBoundingRect();
        if (r && isFinite(r.width) && r.width >= 0 && isFinite(r.left)) {
          return { left: r.left, top: r.top, width: r.width, height: r.height };
        }
      }
    } catch (e) { }
    try {
      var w = o.getScaledWidth ? o.getScaledWidth() : ((o.width || 0) * (o.scaleX || 1));
      var h = o.getScaledHeight ? o.getScaledHeight() : ((o.height || 0) * (o.scaleY || 1));
      var l = o.left || 0, t = o.top || 0;
      if (o.originX === 'center') l -= w / 2;
      if (o.originY === 'center') t -= h / 2;
      return { left: l, top: t, width: w, height: h };
    } catch (e) { return null; }
  }
  /* 把对象摆到「中心点 (x,y)」—— 不依赖对象原先的 origin（add / 切面可能把 origin 改回 left/top） */
  function setCenter(o, x, y) {
    try {
      o.set({ originX: 'center', originY: 'center', left: x, top: y });
      if (o.setCoords) o.setCoords();
    } catch (e) { }
  }

  /* 批量落位 + 加入（所有克隆体共用一次切面） */
  function place(clones, face, chip) {
    var c = CV(); if (!c) { toast('Copy failed'); return; }
    var live = clones.filter(function (x) { return !!x; });
    if (!live.length) { toast('Copy failed'); return; }
    var pa = (window.__pfmPrintArea && window.__pfmPrintArea()) || {};
    var sp = pa[face];
    var hasArea = !!(sp && sp.width > 0 && sp.height > 0);

    /* ① 整组包围盒 + 每件的目标中心（保持相对位置） */
    var plan = [], bb = null;
    for (var i = 0; i < live.length; i++) {
      var r = rectOf(live[i]);
      if (!r) { toast('Copy failed'); return; }
      plan.push({ o: live[i], r: r });
      bb = bb ? {
        left: Math.min(bb.left, r.left), top: Math.min(bb.top, r.top),
        right: Math.max(bb.right, r.left + r.width), bottom: Math.max(bb.bottom, r.top + r.height)
      } : { left: r.left, top: r.top, right: r.left + r.width, bottom: r.top + r.height };
    }
    var bw = bb.right - bb.left, bh = bb.bottom - bb.top;
    var cx = bb.left + bw / 2, cy = bb.top + bh / 2;
    var k = 1;
    if (hasArea && bw > 0 && bh > 0) {
      k = Math.min(1, (sp.width * 0.9) / bw, (sp.height * 0.9) / bh);   /* 保持原大；放不下才等比收敛 */
      if (!isFinite(k) || k <= 0) k = 1;
    }
    var tcx = hasArea ? (sp.left + sp.width / 2) : cx;
    var tcy = hasArea ? (sp.top + sp.height / 2) : cy;
    var targets = plan.map(function (p) {
      return {
        o: p.o,
        x: tcx + (p.r.left + p.r.width / 2 - cx) * k,
        y: tcy + (p.r.top + p.r.height / 2 - cy) * k
      };
    });

    /* ② 先缩放（围绕各自中心 —— 目标中心在第 ③ 步才写，故缩放不会让布局漂移） */
    if (k < 1) {
      for (var j = 0; j < targets.length; j++) {
        var so = targets[j].o;
        so.set({ scaleX: (so.scaleX || 1) * k, scaleY: (so.scaleY || 1) * k });
      }
    }

    /* ③ 只切一次面（内部会 canvas.clear() ⇒ 必须所有克隆体都已就绪）*/
    chip.click();
    for (var m = 0; m < targets.length; m++) {
      try {
        if (window.__pfmAddObject) window.__pfmAddObject(targets[m].o);   /* 含控制点样式 + 选中 + saveState + updateLayers */
        else c.add(targets[m].o);
      } catch (e) { toast('Copy failed'); return; }
    }
    /* ④ 落点兜底（沿用 2026-09-19 的修复）：add / 切面过程可能把 origin 变回 left/top，
          或目标面没有打印区规格 ⇒ 图片会落到打印区外，看起来「图片不显示」。add 之后再落一次点。 */
    for (var n = 0; n < targets.length; n++) setCenter(targets[n].o, targets[n].x, targets[n].y);
    try { c.renderAll(); } catch (e) { }
    try { if (window.__pfmUpdateLayers) window.__pfmUpdateLayers(); } catch (e) { }

    /* ⑤ 切面后旧的勾选索引已指向目标面上的另一批对象 ⇒ 清空，避免误操作 */
    try { if (window.__hdLayers && window.__hdLayers.clearPicks) window.__hdLayers.clearPicks(); } catch (e) { }

    hideList();
    toast(targets.length > 1 ? ('Copied ' + targets.length + ' to ' + labelOf(face)) : ('Copied to ' + labelOf(face)));
  }

  function copyTo(face) {
    var c = CV(); if (!c) return;
    var objs = selObjs();
    if (!objs.length) return;
    var chip = chips().filter(function (x) { return x.dataset.p === face; })[0];
    if (!chip || !faceUsable(face)) { toast('Face not available'); return; }

    /* 全部克隆完再动手：fabric 的 clone 对图片是**异步回调**，逐件 clone 后立刻切面会丢件 */
    var n = objs.length, done = 0, clones = [], placed = false;
    function tryPlace(force) {
      if (placed) return;
      if (!force && done < n) return;
      placed = true;
      place(clones, face, chip);
    }
    for (var i = 0; i < n; i++) {
      (function (o) {
        /* 2026-09-20 修正：fabric 的 clone() = this.constructor.fromObject(toObject(), cb)：
           · Rect/Text 等 fromObject **同步**（回调立刻触发，并同时 return 新对象）
           · **Image / Group 的 fromObject 是异步**（等图片 load 才回调）
           故「回调只认第一次」用幂等 settle —— 三路（同步回调 / Promise / 同步返回值）任一路到齐即计数，
           绝不能凭「clone() 已返回但回调未触发」就判失败（那会在克隆体为空时提前 place ⇒ toast('Copy failed')）。 */
        var settled = false;
        function settle(cl) {
          if (settled) return;
          settled = true;
          if (cl) clones.push(cl);
          done++;
          tryPlace(false);
        }
        try {
          var ret = o.clone(function (cl) { settle(cl); });
          if (ret && typeof ret.then === 'function') ret.then(function (cl) { settle(cl); }, function () { settle(null); });
          else if (ret) settle(ret);
        } catch (e) { settle(null); }
      })(objs[i]);
    }
    /* 兜底：个别对象 clone 回调不触发（图源异常）时，最多等 3s 就用已拿到的克隆体开工 */
    setTimeout(function () { tryPlace(true); }, 3000);
  }

  function bind(c) {
    if (c.__cfBound) return;
    c.__cfBound = true;
    ['selection:created', 'selection:updated', 'selection:cleared', 'object:removed'].forEach(function (ev) {
      try { c.on(ev, function () { sync(); hideList(); }); } catch (e) { }
    });
  }
  function whenCanvas(cb) {
    var n = 0;
    (function t() { var c = CV(); if (c) { cb(c); return; } if (++n > 80) return; setTimeout(t, 200); })();
  }

  function boot() {
    /* 2026-09-20: 常驻 —— 首帧就显示，不等 canvas 就绪（否则「没选中时整行消失」） */
    var _sec = q('pfmCopyFaceSection'); if (_sec) _sec.style.display = 'block';
    sync();
    var btn = q('pfmCopyFaceBtn');
    if (btn && !btn.__cfBtn) { btn.__cfBtn = true; btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); buildList(); }); }
    var list = q('pfmCopyFaceList');
    if (list && !list.__cfL) {
      list.__cfL = true;
      list.addEventListener('click', function (e) {
        var t = e.target.closest ? e.target.closest('[data-cf]') : null;
        if (!t) return;
        e.preventDefault(); e.stopPropagation();
        copyTo(t.dataset.cf);
      });
    }
    whenCanvas(function (c) { bind(c); sync(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  setTimeout(boot, 1500);   /* board 后开也兜一次（幂等） */
})();
